import React from 'react';
import clsx from 'clsx';

import './type-card.scss';

const TypeCard = (props) => {
  const { selected, className, name, title, desc, img = {}, children, ...restProps } = props;
  const { imgUrl, alt } = img;
  return (
    <div
      className={clsx(
        'cards-container__card',
        'type-card',
        `type-card--${name}`,
        selected && 'type-card--selected',
        className,
      )}
      {...restProps}
    >
      {imgUrl && alt && (
        <img
          className="type-card__image"
          alt={alt}
          src={imgUrl}
        />
      )}
      {!imgUrl && !alt && children}
      <div className="type-card__body">
        <h5 className="type-card__title">{title}</h5>
        <p className="type-card__description">
          {desc}
        </p>
      </div>
    </div>
  );
};

export default TypeCard;
